import React from 'react'
import './Team.css'

import tawhid from '../../assets/Tawhid.jpg';
import bristy from '../../assets/smbristy.jpg';

import logo1 from '../../assets/logo1.png';
import logo2 from '../../assets/logo2.png';
import logo3 from '../../assets/logo3.png';
import logo4 from '../../assets/logo4.png';
import logo5 from '../../assets/logo5.png';
import logo6 from '../../assets/logo6.png';
import logo7 from '../../assets/logo7.png';

import {AiFillLinkedin} from 'react-icons/ai';

import joe from '../../assets/joe.jpg';
import sydney from '../../assets/sydnye.png';
import timothyaxman from '../../assets/timothyaxman.png';
import pyzana from '../../assets/pyzana.png';

const Team = () => {
  return (
    <section id="team">
        <div className="team-container">
            <h1 className="container-title">Our Team</h1>
            <span className="container-des">Meet the Experts Behind WebHarvester Agency</span>


            <div className="members-container">
            <div className="member-details">
                    <div className="member-image">
                        <img src={bristy} alt="" loading='lazy' />
                    </div>

                    <div className="member-des">
                        <div className="member-info">
                            <span className="member-name">Sabrina Bristy</span>
                            <span className="linkedin"><a href="https://www.linkedin.com/in/smbristy/" target='blank'><AiFillLinkedin /></a></span>
                        </div>

                        <span className="member-role">Co-Founder <br/> Lead Generation Expert</span>

                        <span className="member-text">Meet Sabrina Bristy, an expert in lead generation with a proven track record of helping 500+ businesses expand their customer base and boost revenue. Sabrina is passionate about your business's success. Let's grow together.</span>
                    </div>
                </div>
                <div className="member-details">
                    <div className="member-image">
                        <img src={tawhid} alt="" loading='lazy' />
                    </div>

                    <div className="member-des">
                        <div className="member-info">
                            <span className="member-name">Tawhidul Islam</span>
                            <span className="linkedin"><a href="https://www.linkedin.com/in/nomanuap/" target='blank'><AiFillLinkedin /></a></span>
                        </div>

                        <span className="member-role">Co-Founder <br/> Web Research Expert</span>

                        <span className="member-text">Meet Tawhid, a seasoned lead generation expert with over 7 years of experience. He's worked with top IT companies, becoming a master of web research and efficient tools. Ready to help your business grow!</span>
                    </div>
                </div>
            </div>
        </div>

        <div className="worked-with">
            <h1 className="worked-with-title">Among Our Clients</h1>

            <div className="clients-logo-container">
                <div className="slide-track">
                    <div className="logo-slide">
                        <img src={logo1} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo2} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo3} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo4} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo5} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo6} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo7} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo1} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo2} alt="" loading='lazy' />
                    </div>
                    <div className="logo-slide">
                        <img src={logo3} alt="" loading='lazy' />
                    </div>
                </div>
            </div>
        </div>

        <div className="testimonial">

            <h1 className="container-title">Client Testimonials</h1>
            <span className="container-des">Hear What Our Clients Have to Say About Us</span>

            <div className="testimonial-container">
                <div className="testimonial-content">
                    <div className="testimonial-image">
                        <img src={joe} alt="" loading='lazy' />
                    </div>
                    <div className="testimonial-flex">
                        <div className="testimonial-name">
                            <span>joeldelasheras</span>
                        </div>
                        <div className="testimonial-star-bar">
                            <span>★★★★★</span>
                        </div>
                        <div className="testimonial-review">
                            <span>Thank you very much for helping me with the task of lead prospecting. You offer me a very good starting point that clarifies how to approach the communication and strategic approach. A service that offers calm and executed with a lot of professionalism and seriousness. I hope to have the possibility to work with you again. Have a nice day!</span>
                        </div>
                    </div>
                </div>
                <div className="testimonial-content">
                    <div className="testimonial-image">
                        <img src={sydney} alt="" loading='lazy' />
                    </div>
                    <div className="testimonial-flex">
                        <div className="testimonial-name">
                            <span>sydneyberry225</span>
                        </div>
                        <div className="testimonial-star-bar">
                            <span>★★★★★</span>
                        </div>
                        <div className="testimonial-review">
                            <span>Great delivery per usual. They are very fast, detailed and efficient and do a very diligent job researching and scraping for data. I appreciate the updates and follow-up questions to ensure the deliverable is exactly what we wanted. I will definitely continue to use them for our B2B lead gen needs.</span>
                        </div>
                    </div>
                </div>
                <div className="testimonial-content">
                    <div className="testimonial-image">
                        <img src={timothyaxman} alt="" loading='lazy' />
                    </div>
                    <div className="testimonial-flex">
                        <div className="testimonial-name">
                            <span>timothyaxman</span>
                        </div>
                        <div className="testimonial-star-bar">
                            <span>★★★★★</span>
                        </div>
                        <div className="testimonial-review">
                            <span>Sabrina definitely delivered! We talked a bit before the order was made, she understood the task perfectly and she was very clear in her communication about what to expect, but I still feel the delivery was over my expectations. She's very good at what she does and for her price, it's a steal. I will definitely hire her again and continuously every time I need more leads. 5/5 stars!</span>
                        </div>
                    </div>
                </div>
                <div className="testimonial-content">
                    <div className="testimonial-image">
                        <img src={pyzana} alt="" loading='lazy' />
                    </div>
                    <div className="testimonial-flex">
                        <div className="testimonial-name">
                            <span>pyzana</span>
                        </div>
                        <div className="testimonial-star-bar">
                            <span>★★★★★</span>
                        </div>
                        <div className="testimonial-review">
                            <span>I am 100% satisfied with Sabrina's lead generation services! I highly recommend her services. Communication was smooth and super fast. She provided exactly what I needed and more. The data was perfectly laid out and sorted in an excel file. I look forward to hire her again in the future.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Team;